/**
 * Utility helper functions
 */

/**
 * Sleep/delay function that returns a promise
 * Useful for adding delays between API calls to allow server-side operations to complete
 * @param {number} ms - Milliseconds to sleep
 * @returns {Promise} Promise that resolves after the specified delay
 */
export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * Format a birth or death date without shifting date-only values across timezones.
 * Accepts the YYYY-MM-DD strings returned by private endpoints and the timestamps
 * returned by public endpoints.
 */
export function formatLifeDate(value) {
  if (!value) return ''

  const date = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? new Date(`${value}T12:00:00`)
    : new Date(value)

  if (Number.isNaN(date.getTime())) return ''

  return date.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })
}
